import React, {createContext, useEffect} from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import JssProvider from "react-jss/lib/JssProvider";
import {
  MuiThemeProvider,
  createGenerateClassName
} from "@material-ui/core/styles";
import {defaultState} from "./defaultState";
import {disabledSearchPages} from "./config";
import {Pane} from "./components/Pane";
import {Header} from "./components/Header";
import {StickyHeader} from "./components/StickyHeader";
import {VTBCartContainer} from "./components/VTBCartContainer";

import styles from "./header.module.scss";
import {getMuiTheme} from "../../../javascripts/getMaterialTheme";

export const Context = createContext(defaultState);

export default function App({state, materialUI}) {
  const onPlatform = state.onPlatform;

  const theme = getMuiTheme(onPlatform);

  const generateClassName = createGenerateClassName({
    productionPrefix: `${materialUI}-react-app`
  });

  useEffect(() => {
    const jssStyles = document.getElementById(`jss-server-side-${materialUI}`);
    if (jssStyles && jssStyles.parentNode) {
      jssStyles.parentNode.removeChild(jssStyles);
    }
  }, [materialUI]);

  const isStickyHeaderDisabled = disabledSearchPages.some((regexp) =>
    regexp.test(state.fullpath)
  );

  return (
    <JssProvider generateClassName={generateClassName}>
      <MuiThemeProvider theme={theme}>
        <Context.Provider value={{...defaultState, ...state}}>
          {onPlatform !== `vtb` ? (
            <header
              className={classnames(styles.container, {
                [styles.containerVTB]: onPlatform === `vtb`
              })}
            >
              <Pane />
              {!isStickyHeaderDisabled && <StickyHeader />}
              <Header />
            </header>
          ) : (
            <VTBCartContainer />
          )}
        </Context.Provider>
      </MuiThemeProvider>
    </JssProvider>
  );
}

App.propTypes = {
  materialUI: PropTypes.string,
  state: PropTypes.shape({
    authenticityToken: PropTypes.string,
    onPlatform: PropTypes.string,
    fullpath: PropTypes.string,
    user: PropTypes.shape({
      name: PropTypes.string,
      admin: PropTypes.bool
    }),
    cartItems: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number,
        name: PropTypes.string,
        type: PropTypes.string,
        price: PropTypes.number,
        amount: PropTypes.number,
        picture: PropTypes.string,
        removeLink: PropTypes.string
      })
    ),
    menu: PropTypes.arrayOf(
      PropTypes.shape({
        title: PropTypes.string,
        path: PropTypes.string,
        children: PropTypes.arrayOf(
          PropTypes.shape({
            title: PropTypes.string,
            path: PropTypes.string,
            children: PropTypes.arrayOf(
              PropTypes.shape({
                title: PropTypes.string,
                path: PropTypes.string
              })
            )
          })
        )
      })
    )
  })
};
